import { Inject, Injectable } from '@angular/core';
import { CrudService } from 'src/app/core/services/crud.service';
import { QueryService } from 'src/app/core/services/query.service';
import { CATALOG_SPINNERET_ENDPOINT, CATALOG_SPINNERET_QUERY_SERVICE_INSTANCE } from '../filiere.config';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from 'src/app/core/services/snackbar-psa.service';

@Injectable({
  providedIn: 'root'
})
export class CatalogSpinneretService extends CrudService<any> {

  constructor(
        @Inject(CATALOG_SPINNERET_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<any>,
        public readonly apiFluxService: ApiService,
        protected  override readonly snackbar : SnackbarService
      ) {
        super(CATALOG_SPINNERET_ENDPOINT, apiFluxService, snackbar);
      }
}
